import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const DispatchArrivalService = {
    apply: async (payload) => axios.post(API_URL + "/dispatch_arrival/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
};

export default DispatchArrivalService;